module.exports = __webpack_public_path__ + "img/cate-icon-5.062458d1.png";